(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-hero"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.mediaItems = Array.from(
          this.querySelectorAll('.product-media-modal__content > [data-media-id]')
        );
        this.currentIndex = 0;

        // The inline gallery/slider this modal belongs to, so navigating in the
        // modal keeps the slider and its thumbnails in sync.
        this.sectionId = this.id.replace('ProductModal-', '');
        this.mediaGallery = document.getElementById(`MediaGallery-${this.sectionId}`);

        const prevButton = this.querySelector('.product-media-modal__nav--prev');
        const nextButton = this.querySelector('.product-media-modal__nav--next');
        // Nav buttons sit outside deferred-media/product-model, so the media-modal's
        // pointerup-to-close handler would otherwise dismiss the modal on click.
        [prevButton, nextButton].forEach((button) => {
          if (!button) return;
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });
        if (prevButton) prevButton.addEventListener('click', () => this.setActiveMedia(this.currentIndex - 1));
        if (nextButton) nextButton.addEventListener('click', () => this.setActiveMedia(this.currentIndex + 1));

        this.counterCurrent = this.querySelector('.product-media-modal__counter-current');

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ARROWLEFT') this.setActiveMedia(this.currentIndex - 1);
          if (event.code.toUpperCase() === 'ARROWRIGHT') this.setActiveMedia(this.currentIndex + 1);
        });
      }

      hide() {
        super.hide();
        // Sync the inline slider once the modal is closed: the fullscreen modal
        // suppresses the slider's scroll while open (notably the mobile swipe
        // slider), so the scroll only commits reliably after it closes.
        const activeMedia = this.mediaItems[this.currentIndex];
        if (activeMedia) this.syncGallery(activeMedia.getAttribute('data-media-id'));
      }

      show(opener) {
        super.show(opener);
        const openedId = this.openedBy.getAttribute('data-media-id');
        const index = this.mediaItems.findIndex(
          (item) => item.getAttribute('data-media-id') === openedId
        );
        this.setActiveMedia(index === -1 ? 0 : index);
      }

      setActiveMedia(index) {
        if (this.mediaItems.length === 0) return;
        // Wrap around so prev/next loop through the gallery.
        this.currentIndex = (index + this.mediaItems.length) % this.mediaItems.length;

        // Stop any video/model playing in the item we're leaving.
        window.pauseAllMedia();

        this.mediaItems.forEach((item, i) => {
          item.classList.toggle('active', i === this.currentIndex);
        });

        const activeMedia = this.mediaItems[this.currentIndex];
        const container = this.querySelector('[role="document"]');
        if (container) container.scrollTop = 0;

        if (this.counterCurrent) this.counterCurrent.textContent = this.currentIndex + 1;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      // Move the inline slider/thumbnails to match the image shown in the modal.
      syncGallery(mediaId) {
        if (!this.mediaGallery || !mediaId) return;
        const galleryMediaId = `${this.sectionId}-${mediaId}`;
        const slide = this.mediaGallery.querySelector(
          `[id^="GalleryViewer"] [data-media-id="${galleryMediaId}"]`
        );
        // Skip variant images that `hide_variants` keeps hidden from the inline
        // slider, so it doesn't switch to a permanently hidden slide.
        if (!slide || slide.classList.contains('product__media-item--variant')) return;
        this.mediaGallery.setActiveMedia(galleryMediaId, false);
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.mediaItems = Array.from(
        this.querySelectorAll('.product-media-modal__content > [data-media-id]')
      );
      this.currentIndex = 0;

      // The inline gallery/slider this modal belongs to, so navigating in the
      // modal keeps the slider and its thumbnails in sync.
      this.sectionId = this.id.replace('ProductModal-', '');
      this.mediaGallery = document.getElementById(`MediaGallery-${this.sectionId}`);

      const prevButton = this.querySelector('.product-media-modal__nav--prev');
      const nextButton = this.querySelector('.product-media-modal__nav--next');
      // Nav buttons sit outside deferred-media/product-model, so the media-modal's
      // pointerup-to-close handler would otherwise dismiss the modal on click.
      [prevButton, nextButton].forEach((button) => {
        if (!button) return;
        button.addEventListener('pointerup', (event) => event.stopPropagation());
      });
      if (prevButton) prevButton.addEventListener('click', () => this.setActiveMedia(this.currentIndex - 1));
      if (nextButton) nextButton.addEventListener('click', () => this.setActiveMedia(this.currentIndex + 1));

      this.counterCurrent = this.querySelector('.product-media-modal__counter-current');

      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ARROWLEFT') this.setActiveMedia(this.currentIndex - 1);
        if (event.code.toUpperCase() === 'ARROWRIGHT') this.setActiveMedia(this.currentIndex + 1);
      });
    }

    hide() {
      super.hide();
      // Sync the inline slider once the modal is closed: the fullscreen modal
      // suppresses the slider's scroll while open (notably the mobile swipe
      // slider), so the scroll only commits reliably after it closes.
      const activeMedia = this.mediaItems[this.currentIndex];
      if (activeMedia) this.syncGallery(activeMedia.getAttribute('data-media-id'));
    }

    show(opener) {
      super.show(opener);
      const openedId = this.openedBy.getAttribute('data-media-id');
      const index = this.mediaItems.findIndex(
        (item) => item.getAttribute('data-media-id') === openedId
      );
      this.setActiveMedia(index === -1 ? 0 : index);
    }

    setActiveMedia(index) {
      if (this.mediaItems.length === 0) return;
      // Wrap around so prev/next loop through the gallery.
      this.currentIndex = (index + this.mediaItems.length) % this.mediaItems.length;

      // Stop any video/model playing in the item we're leaving.
      window.pauseAllMedia();

      this.mediaItems.forEach((item, i) => {
        item.classList.toggle('active', i === this.currentIndex);
      });

      const activeMedia = this.mediaItems[this.currentIndex];
      const container = this.querySelector('[role="document"]');
      if (container) container.scrollTop = 0;

      if (this.counterCurrent) this.counterCurrent.textContent = this.currentIndex + 1;

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    // Move the inline slider/thumbnails to match the image shown in the modal.
    syncGallery(mediaId) {
      if (!this.mediaGallery || !mediaId) return;
      const galleryMediaId = `${this.sectionId}-${mediaId}`;
      const slide = this.mediaGallery.querySelector(
        `[id^="GalleryViewer"] [data-media-id="${galleryMediaId}"]`
      );
      // Skip variant images that `hide_variants` keeps hidden from the inline
      // slider, so it doesn't switch to a permanently hidden slide.
      if (!slide || slide.classList.contains('product__media-item--variant')) return;
      this.mediaGallery.setActiveMedia(galleryMediaId, false);
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
